export default "__VITE_ASSET__B6i9mYQ0__"